import { createContext } from 'react'

const schedulePickupContext = createContext()

export default schedulePickupContext
